import React from 'react';
import translations from './translations';

const defaultLanguage = 'en';

const getInitialLanguage = () => {
  if (typeof window === 'undefined') {
    return defaultLanguage;
  }

  const savedLanguage = window.localStorage.getItem('grain-bites-language');
  return translations[savedLanguage] ? savedLanguage : defaultLanguage;
};

export const I18nContext = React.createContext({
  language: defaultLanguage,
  setLanguage: () => {},
  t: key => key,
});

export class I18nProvider extends React.Component {
  state = {
    language: getInitialLanguage(),
  };

  setLanguage = language => {
    if (!translations[language]) {
      return;
    }

    this.setState({ language });

    if (typeof window !== 'undefined') {
      window.localStorage.setItem('grain-bites-language', language);
    }
  };

  translate = key => {
    const keys = key.split('.');
    const languageText = keys.reduce((value, part) => value && value[part], translations[this.state.language]);
    const fallbackText = keys.reduce((value, part) => value && value[part], translations[defaultLanguage]);

    return languageText || fallbackText || key;
  };

  render() {
    return (
      <I18nContext.Provider
        value={{
          language: this.state.language,
          setLanguage: this.setLanguage,
          t: this.translate,
        }}
      >
        {this.props.children}
      </I18nContext.Provider>
    );
  }
}

export const useI18n = () => React.useContext(I18nContext);
